/** Constantes de feedback visual y sonoro. Solo afectan al render. */
export const JUICE = {
  SHAKE: {
    /** Trauma maximo acumulable (0-1). */
    MAX: 1,
    /** Cuanto decae el trauma por segundo. */
    DECAY: 5.5,
    /** Desplazamiento maximo en pixeles de pantalla. */
    MAX_OFFSET: 14,
  },
  CAMERA: {
    /** Zoom extra al marcar (multiplicador sobre el fit-to-screen). */
    GOAL_ZOOM: 1.38,
    /** Segundos para acercar tras el gol. */
    GOAL_ZOOM_IN: 0.35,
    /** Segundos para volver al encuadre normal (al empezar el replay). */
    GOAL_ZOOM_OUT: 0.75,
    /**
     * Acercamiento lento durante la repeticion.
     *
     * Es lo unico que dice "esto es una repeticion" sin escribirlo: una camara
     * de juego persigue, una camara de repeticion se acerca sola. Discreto a
     * proposito — un 12% a lo largo del clip se percibe sin llegar a leerse
     * como un zoom.
     */
    REPLAY_ZOOM: 1.12,
    /** Zoom breve al soltar un tiro cargado. */
    SHOT_PUNCH: 0.1,
    SHOT_PUNCH_DECAY: 9,
  },
  PARTICLES: {
    MAX: 280,
    /** Vida base de un chispazo de golpeo (s). */
    KICK_LIFE: 0.35,
    /** Vida de confeti de gol (s). */
    GOAL_LIFE: 1.4,
  },
  AUDIO: {
    MASTER: 0.55,
  },
  /** Murmullo de estadio y reacciones de grada (solo render). */
  AMBIENT: {
    BASE_LEVEL: 0.2,
    MAX_LEVEL: 0.42,
    SHIMMER_LEVEL: 0.055,
    AIR_LEVEL: 0.035,
    CHEER_PEAK: 0.38,
    CHEER_TONE: 0.07,
    CHEER_DURATION: 2.6,
    CHEER_BED_BOOST: 0.22,
    CHEER_DECAY: 2.8,
    SWELL_BED_BOOST: 0.12,
    SWELL_DECAY: 1.1,
    GASP_BED_BOOST: 0.08,
    GASP_DECAY: 0.85,
    CHATTER_MIN: 9,
    CHATTER_MAX: 22,
  },
} as const;
